

























































































































import { Vue, Component } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import CardTitle from "../../components/CardTitle.vue";
import { StudentInfo } from "../../_models/studentInfo";
import { router } from "../../_router";
import ActivitiesDocDialog from "../../components/Dialogs/ActivitiesDocDialog.vue";
import * as temp from "../../_store/temp.module";

@Component({
	components: {
		CardTitle,
		ActivitiesDocDialog
	}
})
export default class StudentsModules extends Vue {
	private titleParams: object;
	private docList: object[];
	private tirociniEstivi: any[];
	private tirociniFormativi: number[];
	private tirociniReIns: number[];
	private alternanze: any[];
	private lastYearSub: number;
	private currentYear: number;

	private showDocDialog: boolean;

	constructor() {
		super();
		this.titleParams = {
			title: "Moduli",
			cols: "10",
			sm: "5",
			md: "5",
			lg: "4"
		};
		this.docList = [];
		this.tirociniEstivi = [];
		this.tirociniFormativi = [];
		this.tirociniReIns = [];
		this.alternanze = [];
		this.showDocDialog = true;
		this.lastYearSub = 0;
		this.currentYear = 0;
	}

	toAuthModule(idDoc: any) {
		//controllo completezza info profilo
		var studentInfo = user.readStudentInfo(this["$store"]);
		var checkCompleteInfo = userUtils.checkStudentInfo(studentInfo);
		if (checkCompleteInfo) {
			router.push({
				name: "authorizationPage",
				params: {
					idDoc: idDoc
				}
			});
		} else {
			bus.$emit("incompleteInfo");
		}
	}

	toReviewAuthModule(idDoc: any, idStatoDoc: any) {
		var userInfo = user.readStudentInfo(this["$store"]);
		var ruoloUtente: any = userInfo.ruoloUtente;
		router.push({
			name: "review",
			params: {
				docType: "autorizzazioneStudente",
				idDoc: idDoc,
				idStatoDoc: idStatoDoc,
				ruoloUtente: ruoloUtente
			}
		});
	}

	loadStudentModules(idStudente: number, idAnnoScolastico: number) {
		var item: number;
		var payload = {
			idStudente: idStudente,
			idAnnoScolastico: idAnnoScolastico
		};
		data
			.dispatchStudentDoc(this["$store"], payload)
			.then(resp => {
				this.docList = resp;
			})
			.catch(error => {
				if (error.response.status === 401) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	loadActivityDocs(idStudente: number) {
		//da implementare con tutte le attività
		var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
		var payload = {
			idAllievo: idStudente,
			idAnnoScolastico: idAnnoScolastico
		};
		data
			.dispatchRichiesteAlternanzaAllievo(this["$store"], payload)
			.then(result => {
				this.alternanze = result;
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
		data
			.dispatchRichiesteTirEstiviAllievo(this["$store"], payload)
			.then(result => {
				this.tirociniEstivi = result;
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
		data
			.dispatchRichiesteTirFormativiAllievo(this["$store"], payload)
			.then(result => {
				this.tirociniFormativi = result;
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
		data
			.dispatchRichiesteTirReInsAllievo(this["$store"], payload)
			.then(result => {
				this.tirociniReIns = result;
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	async lastYearSubscription() {
		var studentInfo = user.readStudentInfo(this["$store"]);
		var payload = {
			idAllievo: studentInfo.idUtente
		};
		return new Promise<number>((resolve, reject) => {
			data
				.dispatchLastYearSubscription(this["$store"], payload)
				.then(result => {
					resolve(result);
				})
				.catch(error => {
					reject(error);
				});
		});
	}

	created() {
		var token = localStorage.getItem("userToken");
		var studentInfo: StudentInfo;
		var parsedToken: any;
		if (token !== null) {
			parsedToken = userUtils.parseToken(token);
		}
		var payload = {
			idUtente: parsedToken.IdUtente,
			tipoSoggetto: parsedToken.IdTipoSoggetto,
			username: parsedToken.Username
		};
		user
			.dispatchSetStudentInfo(this["$store"], payload)
			.then(() => {
				bus.$emit("loadMenu");
				studentInfo = user.readStudentInfo(this["$store"]);
				var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
				this.currentYear = idAnnoScolastico
				this.lastYearSubscription().then(result => {
					this.lastYearSub = result;
				});
				this.loadStudentModules(studentInfo.idUtente, idAnnoScolastico);
				this.loadActivityDocs(studentInfo.idUtente);
				// user
				//   .dispatchSetInstituteInfo(this["$store"])
				//   .then(() => {
				//     bus.$emit("loadMenu");
				//   })
				//   .catch(() => {
				//     bus.$emit("stopLoading");
				//     auth.dispatchLogout(this["$store"]);
				//     user.dispatchClearState(this["$store"]);
				//     this["$router"].push("/sessionExpired");
				//   });
			})
			.catch(() => {
				bus.$emit("stopLoading");
				auth.dispatchLogout(this["$store"]);
				user.dispatchClearState(this["$store"]);
				this["$router"].push("/sessionExpired");
			});

		bus.$on("destroyDocDialog", async () => {
			this.showDocDialog = false;
			await this.$nextTick();
			this.showDocDialog = true;
		});

		bus.$on("loadActivityDocs", () => {
			var studentInfo = user.readStudentInfo(this["$store"]);
			this.loadActivityDocs(studentInfo.idUtente);
		});
	}
}
